import { render, staticRenderFns } from "./add-memory.vue?vue&type=template&id=2a8f4b81&scoped=true&"
import script from "./add-memory.vue?vue&type=script&lang=js&"
export * from "./add-memory.vue?vue&type=script&lang=js&"
import style0 from "./add-memory.vue?vue&type=style&index=0&id=2a8f4b81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f4b81",
  null
  
)

export default component.exports